const {zip} = window

zip.workerScriptsPath = '/static/js/'

export default class KmzParser {
  static getKmzData (kmzUrl) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open('GET', kmzUrl.replace(/^https?:\/\/[^/]+/, ''), true)
      xhr.responseType = 'arraybuffer'
      xhr.onreadystatechange = event => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 0) {
            this.readKmz(event.target.response, xml => {
              resolve(this.getData(xml))
              // this.plot(xml)
            })
          }
        }
      }
      xhr.onerror = reject
      xhr.send(null)
    })
  }

  static readKmz (response, callback) {
    let responseArray = new Uint8Array(response)
    let blobData = new Blob([responseArray], {type: 'application/zip'})
    let {zip} = window

    zip.createReader(new zip.BlobReader(blobData), reader => {
      reader.getEntries(entries => {
        if (entries.length) {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].filename.indexOf('.kml') !== -1) {
              entries[i].getData(new zip.TextWriter(), callback)
            }
          }
        }
      })
    })
  }

  static getData (xml) {
    let kml = new DOMParser().parseFromString(xml, 'text/xml')
    let styleMap = [...kml.querySelectorAll('Document > Style')].reduce((map, style) => {
      map[`#${style.id}`] = {
        line: {
          color: style.querySelector('LineStyle > color').textContent.trim().replace(/^ff/i, '#')
        }
      }
      return map
    }, {})
    let folders = [...kml.querySelectorAll('Document > Folder')]
    let {length} = folders
    let data = []
    const ENTER = String.fromCharCode(10)

    for (let i = 3; i < length; i++) {
      let folder = folders[i]

      let placemarks = folder.querySelectorAll('Folder > Folder > Placemark')
      let placemarksLen = placemarks.length
      let times = [new Date(placemarks[0].querySelector('end').textContent.trim())]

      for (let j = 0; j < placemarksLen; j++) {
        times.push(new Date(placemarks[j].querySelector('begin').textContent.trim()))
      }

      let coordinates = folder.querySelector('LineString > coordinates')
      let points = coordinates.textContent.split(ENTER)
      let pointsLen = points.length - 1
      let lngLats = []

      for (let j = 1; j < pointsLen; j++) {
        let point = points[j].split(',')
        lngLats.push({
          time: times[j - 1],
          lngLat: [Number(point[0]), Number(point[1])],
          value: Number(point[2])
        })
      }

      let name = folder.querySelector('name')
      let styleUrl = folder.querySelector('styleUrl')

      data.push({
        name: `${Number(/^\d+\.?\d*/.exec(name.textContent.trim())[0])}米`,
        style: styleMap[styleUrl.textContent.trim()],
        points: lngLats
      })
    }

    return data
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/KmzParser.js